import {
  addAvatar,
  addBetLimit,
  createAccessCodes,
  createTournament,
  deleteAvatar,
  deleteTournament,
  getGame,
  getTrainEventStatus,
  getTournaments,
  updateAvatar,
  updateGame,
  updateGameAethir
} from 'services/games';
import { io } from 'socket.io-client';
import { useContext, useEffect, useMemo, useState } from 'react';
import dayjs from 'dayjs';
import { useToast } from 'context/ToastContext';
import MDTypography from 'components/MDTypography';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'components/DashboardNavbar';
import MDBox from 'components/MDBox';
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid
} from '@mui/material';
import { DateTimePicker, LocalizationProvider, pickersLayoutClasses } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import MDButton from 'components/MDButton';
import BetLimit from './components/BetLimit';
import { useNavigate } from 'react-router-dom';
import { convertUTCTimeToLocal, localTimeToUTC } from 'services/metrics';
import { editTournament } from 'services/tournaments/edit-tournament';
import MDInput from 'components/MDInput';
import { AbilityContext, Can } from 'context';

const darkInputSx = {
  '& .MuiInputLabel-root': { color: 'rgba(223,232,250,0.88)' },
  '& .MuiInputLabel-root.MuiInputLabel-shrink': { color: 'rgba(223,232,250,0.82)' },
  '& .MuiInputLabel-root.Mui-focused': { color: '#22d3ee' },
  '& .MuiInputBase-input': {
    color: '#e6eefc',
    WebkitTextFillColor: '#e6eefc'
  },
  '& .MuiPickersSectionList-root, & .MuiPickersSectionList-section, & .MuiPickersInputBase-sectionsContainer': {
    color: '#e6eefc'
  },
  '& .MuiInputBase-input::placeholder': {
    color: 'rgba(223,232,250,0.62)',
    opacity: 1
  },
  '& .MuiFormHelperText-root': {
    color: '#9fd3ff',
    marginLeft: 0,
    marginRight: 0
  },
  '& .MuiIconButton-root, & .MuiSvgIcon-root, & .MuiInputAdornment-root .MuiButtonBase-root': {
    color: 'rgba(211,221,245,0.82)'
  },
  '& .MuiOutlinedInput-root': {
    backgroundColor: 'rgba(255,255,255,0.06)',
    '& fieldset': { borderColor: 'rgba(34,211,238,0.2)' },
    '&:hover fieldset': { borderColor: 'rgba(34,211,238,0.45)' },
    '&.Mui-focused fieldset': { borderColor: '#22d3ee' }
  }
};

const darkPickerLayoutSx = {
  [`.${pickersLayoutClasses.actionBar}`]: {
    display: 'none'
  }
};

const currencies = [
  'USD',
  'EUR',
  'FTN',
  'AED',
  'AFN',
  'ALL',
  'AMD',
  'ANG',
  'AOA',
  'ARS',
  'AUD',
  'AWG',
  'AZN',
  'BAM',
  'BBD',
  'BDT',
  'BGN',
  'BHD',
  'BIF',
  'BMD',
  'BND',
  'BOB',
  'BRL',
  'BSD',
  'BTC',
  'BTN',
  'BTS',
  'BWP',
  'BYN',
  'BZD',
  'CAD',
  'CDF',
  'CHF',
  'CLF',
  'CLP',
  'CNH',
  'CNY',
  'COP',
  'CRC',
  'CUC',
  'CUP',
  'CVE',
  'CZK',
  'DASH',
  'DJF',
  'DKK',
  'DOGE',
  'DOP',
  'DZD',
  'EGP',
  'ERN',
  'ETB',
  'ETH',
  'FJD',
  'FUN',
  'FKP',
  'GBP',
  'GEL',
  'GGP',
  'GHS',
  'GIP',
  'GMD',
  'GNF',
  'GTQ',
  'GYD',
  'HKD',
  'HNL',
  'HRK',
  'HTG',
  'HUF',
  'IDR',
  'ILS',
  'IMP',
  'INR',
  'IQD',
  'IRR',
  'ISK',
  'JEP',
  'JMD',
  'JOD',
  'JPY',
  'KES',
  'KGS',
  'KHR',
  'KMF',
  'KPW',
  'KRW',
  'KWD',
  'KYD',
  'KZT',
  'LAK',
  'LBP',
  'LD',
  'LKR',
  'LRD',
  'LSL',
  'LTC',
  'LYD',
  'MAD',
  'MDL',
  'MGA',
  'MKD',
  'MMK',
  'MNT',
  'MOP',
  'MRU',
  'MUR',
  'MVR',
  'MWK',
  'MXN',
  'MYR',
  'MZN',
  'NAD',
  'NGN',
  'NIO',
  'NOK',
  'NPR',
  'NXT',
  'NZD',
  'OMR',
  'PAB',
  'PEN',
  'PGK',
  'PHP',
  'PKR',
  'PLN',
  'PYG',
  'QAR',
  'RON',
  'RSD',
  'RUB',
  'RWF',
  'SAR',
  'SBD',
  'SCR',
  'SDG',
  'SEK',
  'SGD',
  'SHP',
  'SLL',
  'SOS',
  'SRD',
  'SSP',
  'STD',
  'STN',
  'STR',
  'SVC',
  'SYP',
  'SZL',
  'THB',
  'TJS',
  'TMT',
  'TND',
  'TOP',
  'TRY',
  'TTD',
  'TWD',
  'TZS',
  'UAH',
  'UGX',
  'UYU',
  'UZS',
  'VEF_BLKMKT',
  'VEF_DICOM',
  'VEF_DIPRO',
  'VES',
  'VND',
  'VUV',
  'WST',
  'XAF',
  'XAG',
  'XAU',
  'XCD',
  'XDR',
  'XMR',
  'XOF',
  'XPD',
  'XPF',
  'XPT',
  'XRP',
  'YER',
  'ZAR',
  'ZMW',
  'ZWL'
];

const toLocalDateTimeInput = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const offset = date.getTimezoneOffset();
  const localDate = new Date(date.getTime() - offset * 60 * 1000);
  return localDate.toISOString().slice(0, 16);
};

const toLocalToUtcPreview = (value, browserTimezone) => {
  if (!value) return 'Empty -> endless live mode while Enabled is on';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 'Invalid date';

  const localLabel = new Intl.DateTimeFormat('en-GB', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  }).format(date);

  return `${localLabel} ${browserTimezone} -> ${date.toISOString()} UTC`;
};

function Game() {
  const ability = useContext(AbilityContext);
  const navigate = useNavigate();
  let gameId = window.location.pathname.split('/').pop();
  const canManageGame = ability?.can('manage', 'game');
  const canManageLeaderboard = ability?.can('manage', 'leaderboard');
  const [game, setGame] = useState({});
  const [percentTake, setPercentTake] = useState();
  const [takeOnLose, setTakeOnLose] = useState();
  const [minCrash, setMinCrash] = useState();
  const [maxCrash, setMaxCrash] = useState();
  const [minPlayers, setMinPlayers] = useState();
  const [maxPlayers, setMaxPlayers] = useState();
  const [maxExposure, setMaxExposure] = useState();
  const [clientId, setClientId] = useState();
  const [clientName, setClientName] = useState();
  const [callbackUrl, setCallbackUrl] = useState();
  const [betLimits, setBetLimits] = useState();
  const [avatars, setAvatars] = useState();
  const [takingCap, setTakingCap] = useState();

  const [torunaments, setTournaments] = useState([]);

  const [openEditAvatar, setOpenEditAvatar] = useState(false);
  const [editAvatarId, setEditAvatarId] = useState();
  const [editAvatarName, setEditAvatarName] = useState();
  const [editAvatarImage, setEditAvatarImage] = useState();
  const [editAvatarPosition, setEditAvatarPosition] = useState();
  const handleOpenEditAvatar = () => setOpenEditAvatar(true);
  const handleCloseEditAvatar = () => setOpenEditAvatar(false);

  function handleEditAvatarChange(event) {
    setEditAvatarImage(event.target.files[0]);
  }

  const [openAddAvatar, setOpenAddAvatar] = useState(false);
  const [addAvatarName, setAddAvatarName] = useState();
  const [addAvatarImage, setAddAvatarImage] = useState();
  const [addAvatarPosition, setAddAvatarPosition] = useState();
  const handleOpenAddAvatar = () => setOpenAddAvatar(true);
  const handleCloseAddAvatar = () => setOpenAddAvatar(false);

  function handleAddAvatarChange(event) {
    setAddAvatarImage(event.target.files[0]);
  }

  const [openAddBetLimit, setOpenAddBetLimit] = useState(false);
  const [newLimitMinBet, setNewLimitMinBet] = useState();
  const [newLimitMaxBet, setNewLimitMaxBet] = useState();
  const [newLimitSingleBet, setNewLimitSingleBet] = useState();
  const handleOpenAddBetLimit = () => setOpenAddBetLimit(true);
  const handleCloseAddBetLimit = () => {
    setOpenAddBetLimit(false);
    setNewLimitMinBet(null);
    setNewLimitMaxBet(null);
  };

  const [openDeleteAvatar, setOpenDeleteAvatar] = useState();
  const [deleteAvatarId, setDeleteAvatarId] = useState();
  const handleCloseDeleteAvatar = () => setOpenDeleteAvatar(false);
  const handleOpenDeleteAvatar = () => setOpenDeleteAvatar(true);

  const [updateInfo, setUpdateInfo] = useState();
  const [rerender, setRerender] = useState(false);
  const [limitType, setLimitType] = useState('none');

  const [activeSessions, setActiveSessions] = useState(null);

  const [quantity, setQuantity] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [accessCodeBetLimitId, setAccessCodeBetLimitId] = useState('');
  const [loading, setLoading] = useState(false);
  const [tokens, setTokens] = useState([]);
  const [modal, setModal] = useState(false);

  const [copied, setCopied] = useState(false);

  const [aethirId, setAethirId] = useState('');
  const [aethirIdUS, setAethirIdUS] = useState('');
  const [serverIp, setServerIp] = useState('');
  const [isAethirActive, setIsAethirActive] = useState(false);
  const [isAethirUSActive, setIsAethirUSActive] = useState(false);

  const [gameCategory, setGameCategory] = useState('pvp');
  const [theoreticalRtp, setTheoreticalRtp] = useState('');
  const [trainEventEnabled, setTrainEventEnabled] = useState(false);
  const [trainEventStartsAt, setTrainEventStartsAt] = useState('');
  const [trainEventEndsAt, setTrainEventEndsAt] = useState('');
  const [trainEventStatus, setTrainEventStatus] = useState(null);
  const [serverClockMs, setServerClockMs] = useState(null);
  const [serverClockCapturedAtMs, setServerClockCapturedAtMs] = useState(null);
  const [serverClockTickMs, setServerClockTickMs] = useState(Date.now());
  const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'Local browser time';

  const syncServerClock = (eventStatus) => {
    if (!eventStatus?.serverTime) {
      setServerClockMs(null);
      setServerClockCapturedAtMs(null);
      return;
    }

    const parsed = new Date(eventStatus.serverTime).getTime();
    if (Number.isNaN(parsed)) {
      setServerClockMs(null);
      setServerClockCapturedAtMs(null);
      return;
    }

    const captured = Date.now();
    setServerClockMs(parsed);
    setServerClockCapturedAtMs(captured);
    setServerClockTickMs(captured);
  };

  async function fetchGame() {
    const res = await getGame(gameId);
    let eventStatus = null;

    if (canManageGame && res?.game === 'nicehash-game') {
      eventStatus = await getTrainEventStatus(gameId);
    }

    setGame(res || {});
    setTrainEventStatus(eventStatus);
    syncServerClock(eventStatus);
  }

  useEffect(() => {
    fetchGame();
  }, [canManageGame, gameId, rerender]);

  useEffect(() => {
    if (!serverClockMs) return undefined;
    const interval = setInterval(() => {
      setServerClockTickMs(Date.now());
    }, 1000);
    return () => clearInterval(interval);
  }, [serverClockMs]);

  const handleCopy = () => {
    if (!tokens || tokens.length === 0) return;

    const tokenText = tokens.map((t) => t?.code).join('\n'); // Join tokens with line breaks
    navigator.clipboard
      .writeText(tokenText)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000); // Reset "Copied!" after 2s
      })
      .catch((err) => console.error('Failed to copy:', err));
  };

  useEffect(() => {
    // add Aethir checks
    setAethirId(game?.aethirId);
    setAethirIdUS(game?.aethirIdUS);
    // Wait for backend integration
    setServerIp(game?.serverIp);
    setIsAethirActive(game?.isAethirActive);
    setIsAethirUSActive(game?.isAethirUSActive);

    const value = `; ${document.cookie}`;
    let parts = value.split(`; access_token=`);
    if (parts.length === 2) {
      parts = parts.pop().split(';').shift();
    }
    const token = parts;
    if (!token || !gameId || !betLimits) {
      return;
    }
    const socket = io(process.env.REACT_APP_SOCKET_URL, {
      auth: {
        token: token
      },
      path: '/backoffice'
    });
    socket.on('active-sessions', (data) => {
      setActiveSessions(data);
    });
    socket.on('connect', () => {
      socket.emit('listen-for-game', gameId);
    });
    return () => {
      socket.disconnect();
    };
  }, [gameId, betLimits]);

  useEffect(() => {
    if (!updateInfo) return undefined;
    const timeout = setTimeout(() => {
      setUpdateInfo(false);
    }, 6000);
    return () => clearTimeout(timeout);
  }, [updateInfo]);

  // useEffect(() => {
  //   getGame(gameId).then((res) => setGame(res));
  // }, []);

  useEffect(() => {
    if (!canManageLeaderboard) {
      setTournaments([]);
      return;
    }

    getTournaments().then((res) => {
      const tournaments = Array.isArray(res?.data?.data) ? res.data.data : [];
      const filtered = tournaments.filter((tournament) => (tournament.betLimit?.game?.id).toString() === gameId);
      setTournaments(filtered);
    });
  }, [canManageLeaderboard, gameId]);

  const [openAddTournament, setOpenAddTournament] = useState(false);
  const [newTournament, setNewTournament] = useState({
    betLimitId: '',
    name: '',
    startDayOfWeek: '',
    endDayOfWeek: '',
    startTime: '',
    endTime: '',
    firstPlacePrize: '',
    secondPlacePrize: '',
    thirdPlacePrize: '',
    currency: '',
    recurring: true,
    isDaily: false,
    requireAccessCode: false
  });

  const [openDeleteTournament, setOpenDeleteTournament] = useState(false);
  const [deleteTournamentId, setDeleteTournamentId] = useState(false);

  const handleFieldChange = (field, value) => {
    setNewTournament((prev) => ({
      ...prev,
      [field]: value
    }));
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewTournament((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const [newTournamentErrors, setNewTournamentErrors] = useState({
    betLimitId: false,
    name: false,
    startDayOfWeek: false,
    endDayOfWeek: false,
    startTime: false,
    endTime: false,
    firstPlacePrize: false,
    currency: false
  });
  const handleErrorChange = (field, value) => {
    setNewTournamentErrors((prev) => ({
      ...prev,
      [field]: value
    }));
  };
  const checkFormFields = () => {
    const errors = {
      betLimitId: newTournament.betLimitId === '',
      name: newTournament.name === '',
      // Skip day of week validation for daily tournaments
      startDayOfWeek: !newTournament.isDaily && newTournament.startDayOfWeek === '',
      endDayOfWeek: !newTournament.isDaily && newTournament.endDayOfWeek === '',
      startTime: newTournament.startTime === '',
      endTime: newTournament.endTime === '',
      firstPlacePrize: newTournament.firstPlacePrize === '',
      currency: newTournament.currency === ''
    };

    // Update each field's error state
    Object.entries(errors).forEach(([field, hasError]) => {
      handleErrorChange(field, hasError);
    });

    // Return true if any field is empty
    return Object.values(errors).some(Boolean);
  };

  useEffect(() => {
    setPercentTake(game?.percentTake ? game.percentTake : 0);
    setMaxCrash(game?.maxCrash ? game.maxCrash : 0);
    setMinCrash(game?.minCrash ? game.minCrash : 0);
    setMaxPlayers(game?.maxPlayers ? game.maxPlayers : 0);
    setMinPlayers(game?.minPlayers ? game.minPlayers : 0);
    setClientId(game?.client?.id ? game.client.id : 0);
    setClientName(game?.client?.name ? game.client.name : 0);
    setCallbackUrl(game?.client?.callbackUrl ? game.client.callbackUrl : 0);
    setBetLimits(game?.betLimits ? game.betLimits : []);
    setAvatars(game?.avatars ? game.avatars : []);
    setTakeOnLose(game?.takeOnLose ? game.takeOnLose : false);
    setTakingCap(game?.takingCap ? game.takingCap : 0);
    setMaxExposure(game?.maxExposure !== null && game?.maxExposure !== undefined ? game.maxExposure : '');
    setGameCategory(game?.gameCategory || 'pvp');
    setTheoreticalRtp(game?.theoreticalRtp !== null && game?.theoreticalRtp !== undefined ? game.theoreticalRtp : '');
    setTrainEventEnabled(Boolean(game?.trainEventEnabled));
    setTrainEventStartsAt(toLocalDateTimeInput(game?.trainEventStartsAt));
    setTrainEventEndsAt(toLocalDateTimeInput(game?.trainEventEndsAt));

    // console.log(game?.betLimits[0]?.singleBet);

    game && game.betLimits && game?.betLimits[0]?.singleBet ? setLimitType('single') : setLimitType('minMax');
  }, [game]);

  async function handleSubmit(e) {
    // stop page from refreshing
    e.preventDefault();
    const res = await createAccessCodes(
      quantity,
      startDate,
      endDate,
      gameId,
      accessCodeBetLimitId || null
    );

    setTokens(res?.data);
    setQuantity('');
    setStartDate('');
    setEndDate('');
    setAccessCodeBetLimitId('');
    handleModal();
  }

  function handleModal() {
    setModal(!modal);
  }

  async function handleTournament(id, enabled) {
    const res = await editTournament(id, { enabled });
    if (res.status === 200 || res.status === 201) {
      const updatedTournaments = torunaments.map((tournament) =>
        tournament.id === id ? { ...tournament, enabled } : tournament
      );
      setTournaments(updatedTournaments);
    }
  }

  const toast = useToast();

  async function saveAethirChecks() {
    try {
      const res = await updateGameAethir(gameId, aethirId, serverIp, isAethirActive, aethirIdUS, isAethirUSActive);
      if (res?.status === 200 || res?.status === 201) {
        toast.success('Aethir checks updated successfully');
      } else {
        toast.error('Failed to update Aethir checks');
      }
    } catch (err) {
      console.error(err);
      toast.error('Failed to update Aethir checks');
    }
  }

  const serverNow = useMemo(() => {
    if (!serverClockMs || !serverClockCapturedAtMs) return null;
    const driftMs = serverClockTickMs - serverClockCapturedAtMs;
    return new Date(serverClockMs + driftMs);
  }, [serverClockCapturedAtMs, serverClockMs, serverClockTickMs]);

  const serverTimeLabel = serverNow ? serverNow.toISOString() : 'Unavailable';
  const trainEventStartLocalToUtcPreview = toLocalToUtcPreview(trainEventStartsAt, browserTimezone);
  const trainEventEndLocalToUtcPreview = toLocalToUtcPreview(trainEventEndsAt, browserTimezone);

  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox px={{ xs: 0, md: 2 }}>
          <MDTypography sx={{ fontWeight: 600 }}>{game?.name ? game.name : '-'}</MDTypography>
          <Grid container sx={{ marginTop: '10px' }} spacing={3}>
            <Grid item xs={12} xl={4}>
              <Grid item xs={12}>
                <MDTypography sx={{ fontSize: '16px', fontWeight: '600' }}>Client Information</MDTypography>
                <MDBox
                  sx={{
                    border: '1px solid rgba(34,211,238,0.15)',
                    borderRadius: '10px',
                    padding: '20px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '20px',
                    background: 'linear-gradient(145deg, #1a2744 0%, #1e3058 50%, #131f3a 100%)',
                    marginTop: '10px'
                  }}
                >
                  <MDBox sx={{ display: 'flex', gap: '10px', alignItems: 'center', justifyContent: 'space-between' }}>
                    <label style={{ fontSize: '14px', color: '#FFF', fontWeight: '600' }}>ID</label>
                    <MDTypography sx={{ fontSize: '14px', color: '#FFF' }}>{clientId}</MDTypography>
                  </MDBox>
                  <MDBox sx={{ display: 'flex', gap: '10px', alignItems: 'center', justifyContent: 'space-between' }}>
                    <label style={{ fontSize: '14px', color: '#FFF', fontWeight: '600' }}>Name</label>
                    <MDTypography sx={{ fontSize: '14px', color: '#FFF' }}>{clientName}</MDTypography>
                  </MDBox>
                  <MDBox sx={{ display: 'flex', gap: '10px', alignItems: 'center', justifyContent: 'space-between' }}>
                    <label style={{ fontSize: '14px', color: '#FFF', fontWeight: '600' }}>Callback URL</label>
                    <MDTypography sx={{ fontSize: '14px', color: '#FFF' }}>{callbackUrl}</MDTypography>
                  </MDBox>
                </MDBox>
              </Grid>
              <Grid item xs={12} sx={{ marginTop: '30px' }}>
                <MDTypography sx={{ fontSize: '16px', fontWeight: '600' }}>Game Information</MDTypography>
                <MDBox
                  sx={{
                    border: '1px solid rgba(34,211,238,0.15)',
                    borderRadius: '10px',
                    padding: '20px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '20px',
                    background: 'linear-gradient(145deg, #1a2744 0%, #1e3058 50%, #131f3a 100%)',
                    marginTop: '10px'
                  }}
                >
                  <MDBox sx={{ display: 'flex', gap: '10px', alignItems: 'center', justifyContent: 'space-between' }}>
                    <label style={{ fontSize: '14px', color: '#FFF', fontWeight: '600' }}>Take on Lose</label>
                    <input
                      type='checkbox'
                      checked={takeOnLose !== undefined ? takeOnLose : false}
                      onChange={(e) => {
                        setTakeOnLose(e.target.checked);
                      }}
                      style={{
                        width: '22px',
                        height: '22px',
                        marginRight: '2px',
                        accentColor: '#22d3ee'
                      }}
                    ></input>
                  </MDBox>
                  <MDBox sx={{ display: 'flex', gap: '10px', alignItems: 'center', justifyContent: 'space-between' }}>
                    <label style={{ fontSize: '14px', color: '#FFF', fontWeight: '600' }}>Percent Take</label>
                    <input
                      type='number'
                      value={percentTake !== undefined ? percentTake : 0}
                      onChange={(e) => {
                        setPercentTake(e.target.value);
                      }}
                      style={{
                        background: 'rgba(255,255,255,0.07)',
                        border: '1px solid rgba(34,211,238,0.2)',
                        color: '#d3ddf5',
                        borderRadius: '8px',
                        padding: '10px 15px'
                      }}
                    ></input>
                  </MDBox>
                  <MDBox sx={{ display: 'flex', gap: '10px', alignItems: 'center', justifyContent: 'space-between' }}>
                    <label style={{ fontSize: '14px', color: '#FFF', fontWeight: '600' }}>Taking Cap</label>
                    <input
                      type='number'
                      value={takingCap !== undefined ? takingCap : 0}
                      onChange={(e) => {
                        setTakingCap(e.target.value);
                      }}
                      style={{
                        background: 'rgba(255,255,255,0.07)',
                        border: '1px solid rgba(34,211,238,0.2)',
                        color: '#d3ddf5',
                        borderRadius: '8px',
                        padding: '10px 15px'
                      }}
                    ></input>
                  </MDBox>
                  <MDBox sx={{ display: 'flex', gap: '10px', alignItems: 'center', justifyContent: 'space-between' }}>
                    <label style={{ fontSize: '14px', color: '#FFF', fontWeight: '600' }}>Min Crash</label>
                    <input
                      type='number'
                      value={minCrash !== undefined ? minCrash : 0}
                      onChange={(e) => {
                        setMinCrash(e.target.value);
                      }}
                      style={{
                        background: 'rgba(255,255,255,0.07)',
                        border: '1px solid rgba(34,211,238,0.2)',
                        color: '#d3ddf5',
                        borderRadius: '8px',
                        padding: '10px 15px'
                      }}
                    ></input>
                  </MDBox>
                  <MDBox sx={{ display: 'flex', gap: '10px', alignItems: 'center', justifyContent: 'space-between' }}>
                    <label style={{ fontSize: '14px', color: '#FFF', fontWeight: '600' }}>Max Crash</label>
                    <input
                      type='number'
                      value={maxCrash !== undefined ? maxCrash : 0}
                      onChange={(e) => {
                        setMaxCrash(e.target.value);
                      }}
                      style={{
                        background: 'rgba(255,255,255,0.07)',
                        border: '1px solid rgba(34,211,238,0.2)',
                        color: '#d3ddf5',
                        borderRadius: '8px',
                        padding: '10px 15px'
                      }}
                    ></input>
                  </MDBox>
                  <MDBox sx={{ display: 'flex', gap: '10px', alignItems: 'center', justifyContent: 'space-between' }}>
                    <label style={{ fontSize: '14px', color: '#FFF', fontWeight: '600' }}>Min Players</label>
                    <input
                      type='number'
                      value={minPlayers !== undefined ? minPlayers : 0}
                      onChange={(e) => {
                        setMinPlayers(e.target.value);
                      }}
                      style={{
                        background: 'rgba(255,255,255,0.07)',
                        border: '1px solid rgba(34,211,238,0.2)',
                        color: '#d3ddf5',
                        borderRadius: '8px',
                        padding: '10px 15px'
                      }}
                    ></input>
                    <span style={{
                      fontSize: '12px',
                      fontWeight: '600',
                      color: Number(minPlayers) <= 1 ? '#4caf50' : '#f44336',
                      background: Number(minPlayers) <= 1 ? 'rgba(76,175,80,0.15)' : 'rgba(244,67,54,0.15)',
                      padding: '4px 10px',
                      borderRadius: '12px'
                    }}>
                      {Number(minPlayers) <= 1 ? '● Bot Enabled' : '● Bot Disabled'}
                    </span>
                    <span style={{ fontSize: '11px', color: '#b8ccef' }}>1=enabled<br />2+=disabled</span>
                  </MDBox>
                  <MDBox sx={{ display: 'flex', gap: '10px', alignItems: 'center', justifyContent: 'space-between' }}>
                    <label style={{ fontSize: '14px', color: '#FFF', fontWeight: '600' }}>Max Players</label>
                    <input
                      type='number'
                      value={maxPlayers !== undefined ? maxPlayers : 0}
                      onChange={(e) => {
                        setMaxPlayers(e.target.value);
                      }}
                      style={{
                        background: 'rgba(255,255,255,0.07)',
                        border: '1px solid rgba(34,211,238,0.2)',
                        color: '#d3ddf5',
                        borderRadius: '8px',
                        padding: '10px 15px'
                      }}
                    ></input>
                  </MDBox>
                  <MDBox sx={{ display: 'flex', gap: '10px', alignItems: 'center', justifyContent: 'space-between' }}>
                    <label style={{ fontSize: '14px', color: '#FFF', fontWeight: '600' }}>Max Exposure</label>
                    <input
                      type='number'
                      value={maxExposure !== undefined ? maxExposure : ''}
                      onChange={(e) => {
                        setMaxExposure(e.target.value);
                      }}
                      placeholder='Unlimited'
                      style={{
                        background: 'rgba(255,255,255,0.07)',
                        border: '1px solid rgba(34,211,238,0.2)',
                        color: '#d3ddf5',
                        borderRadius: '8px',
                        padding: '10px 15px'
                      }}
                    ></input>
                    <span style={{ fontSize: '11px', color: '#b8ccef' }}>Empty = unlimited</span>
                  </MDBox>
                  <MDBox sx={{ display: 'flex', gap: '10px', alignItems: 'center', justifyContent: 'space-between' }}>
                    <label style={{ fontSize: '14px', color: '#FFF', fontWeight: '600' }}>Game Category</label>
                    <select
                      value={gameCategory}
                      onChange={(e) => setGameCategory(e.target.value)}
                      style={{
                        background: 'rgba(255,255,255,0.07)',
                        border: '1px solid rgba(34,211,238,0.2)',
                        color: '#d3ddf5',
                        borderRadius: '8px',
                        padding: '10px 15px',
                        minWidth: '150px'
                      }}
                    >
                      <option value='pvp'>PvP</option>
                      <option value='slot'>Slot</option>
                    </select>
                  </MDBox>
                  {gameCategory === 'slot' && (
                    <MDBox sx={{ display: 'flex', gap: '10px', alignItems: 'center', justifyContent: 'space-between' }}>
                      <label style={{ fontSize: '14px', color: '#FFF', fontWeight: '600' }}>Theoretical RTP (%)</label>
                      <input
                        type='number'
                        step='0.01'
                        min='0'
                        max='100'
                        value={theoreticalRtp}
                        onChange={(e) => setTheoreticalRtp(e.target.value)}
                        placeholder='e.g., 96.50'
                        style={{
                          background: 'rgba(255,255,255,0.07)',
                          border: '1px solid rgba(34,211,238,0.2)',
                          color: '#d3ddf5',
                          borderRadius: '8px',
                          padding: '10px 15px'
                        }}
                      />
                    </MDBox>
                  )}
                  {game?.game === 'nicehash-game' && (
                    <MDBox
                      sx={{
                        border: '1px solid rgba(34,211,238,0.2)',
                        borderRadius: '10px',
                        padding: '14px',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '12px'
                      }}
                    >
                      <MDTypography sx={{ fontSize: '14px', color: '#FFF', fontWeight: '700' }}>
                        Train Event
                      </MDTypography>
                      <MDBox
                        sx={{ display: 'flex', gap: '10px', alignItems: 'center', justifyContent: 'space-between' }}
                      >
                        <label style={{ fontSize: '14px', color: '#FFF', fontWeight: '600' }}>Enabled</label>
                        <input
                          type='checkbox'
                          checked={trainEventEnabled}
                          onChange={(e) => setTrainEventEnabled(e.target.checked)}
                          style={{
                            width: '22px',
                            height: '22px',
                            marginRight: '2px',
                            accentColor: '#22d3ee'
                          }}
                        />
                      </MDBox>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <MDBox
                          sx={{ display: 'flex', gap: '10px', alignItems: 'center', justifyContent: 'space-between' }}
                        >
                          <label style={{ fontSize: '14px', color: '#FFF', fontWeight: '600' }}>Start (Local)</label>
                          <DateTimePicker
                            ampmInClock={false}
                            closeOnSelect={true}
                            ampm={false}
                            disabled={!trainEventEnabled}
                            value={trainEventStartsAt ? dayjs(trainEventStartsAt) : null}
                            onChange={(value) => {
                              setTrainEventStartsAt(value && value.isValid() ? value.format('YYYY-MM-DDTHH:mm') : '');
                            }}
                            viewRenderers={{
                              hours: null,
                              minutes: null,
                              seconds: null
                            }}
                            slotProps={{
                              layout: {
                                sx: darkPickerLayoutSx
                              },
                              textField: {
                                size: 'small',
                                sx: {
                                  minWidth: 250,
                                  ...darkInputSx
                                }
                              }
                            }}
                          />
                        </MDBox>
                        <MDBox
                          sx={{ display: 'flex', gap: '10px', alignItems: 'center', justifyContent: 'space-between' }}
                        >
                          <label style={{ fontSize: '14px', color: '#FFF', fontWeight: '600' }}>End (Local)</label>
                          <DateTimePicker
                            ampmInClock={false}
                            closeOnSelect={true}
                            ampm={false}
                            disabled={!trainEventEnabled}
                            value={trainEventEndsAt ? dayjs(trainEventEndsAt) : null}
                            onChange={(value) => {
                              setTrainEventEndsAt(value && value.isValid() ? value.format('YYYY-MM-DDTHH:mm') : '');
                            }}
                            viewRenderers={{
                              hours: null,
                              minutes: null,
                              seconds: null
                            }}
                            slotProps={{
                              layout: {
                                sx: darkPickerLayoutSx
                              },
                              textField: {
                                size: 'small',
                                sx: {
                                  minWidth: 250,
                                  ...darkInputSx
                                }
                              }
                            }}
                          />
                        </MDBox>
                      </LocalizationProvider>
                      <MDTypography sx={{ fontSize: '12px', color: '#9fd3ff' }}>
                        Leave both dates empty to keep the event live endlessly while Enabled is on.
                      </MDTypography>
                      <MDTypography sx={{ fontSize: '12px', color: '#9fd3ff' }}>
                        Local timezone: {browserTimezone}
                      </MDTypography>
                      <MDTypography sx={{ fontSize: '12px', color: '#9fd3ff' }}>
                        Start conversion: {trainEventStartLocalToUtcPreview}
                      </MDTypography>
                      <MDTypography sx={{ fontSize: '12px', color: '#9fd3ff' }}>
                        End conversion: {trainEventEndLocalToUtcPreview}
                      </MDTypography>
                      <MDTypography sx={{ fontSize: '12px', color: '#9fd3ff' }}>
                        Server time: {serverTimeLabel} ({trainEventStatus?.serverTimezone || 'UTC'})
                      </MDTypography>
                      <MDTypography sx={{ fontSize: '12px', color: '#9fd3ff' }}>
                        Current status: {trainEventStatus?.state || 'unknown'}
                      </MDTypography>
                    </MDBox>
                  )}
                  {updateInfo && (
                    <MDBox sx={{ fontSize: '14px', textAlign: 'center', color: '#fff' }}>
                      Game information was updated successfully.
                    </MDBox>
                  )}
                  <MDButton
                    color={'info'}
                    onClick={async () => {
                      if (game?.game === 'nicehash-game' && trainEventEnabled) {
                        const hasStart = Boolean(trainEventStartsAt);
                        const hasEnd = Boolean(trainEventEndsAt);

                        if (hasStart !== hasEnd) {
                          toast.error('Fill both train event dates, or leave both empty for endless testing.');
                          return;
                        }

                        if (hasStart && hasEnd) {
                          const startTs = new Date(trainEventStartsAt).getTime();
                          const endTs = new Date(trainEventEndsAt).getTime();
                          if (Number.isNaN(startTs) || Number.isNaN(endTs)) {
                            toast.error('Invalid train event date format.');
                            return;
                          }
                          if (startTs >= endTs) {
                            toast.error('Train event start must be before end.');
                            return;
                          }
                        }
                      }

                      try {
                        const updatedGame = await updateGame(
                          gameId,
                          percentTake,
                          minCrash,
                          maxCrash,
                          minPlayers,
                          maxPlayers,
                          takeOnLose,
                          takingCap,
                          gameCategory,
                          theoreticalRtp,
                          maxExposure,
                          game?.game === 'nicehash-game' ? trainEventEnabled : undefined,
                          game?.game === 'nicehash-game' ? trainEventStartsAt : undefined,
                          game?.game === 'nicehash-game' ? trainEventEndsAt : undefined
                        );
                        const status = await getTrainEventStatus(gameId);
                        setGame(updatedGame || {});
                        setTrainEventStatus(status);
                        syncServerClock(status);
                        setUpdateInfo(true);
                      } catch (err) {
                        console.error(err);
                        const message =
                          err?.response?.data?.message ||
                          err?.message ||
                          'Failed to update game information.';
                        toast.error(Array.isArray(message) ? message.join(', ') : message);
                      }
                    }}
                  >
                    Save changes
                  </MDButton>
                </MDBox>
              </Grid>
              <Grid
                item
                xs={12}
                style={{
                  // maxWidth: '400px',
                  margin: '0 auto',
                  padding: '20px',
                  border: '1px solid #ddd',
                  borderRadius: '5px',
                  marginTop: '36px'
                }}
              >
                <MDTypography variant='h3'>Generate Access Tokens</MDTypography>
                <form onSubmit={(e) => handleSubmit(e)}>
                  <div>
                    <MDTypography>
                      <label>Game ID:</label>
                    </MDTypography>
                    <input
                      type='text'
                      value={gameId}
                      disabled
                      style={{ width: '100%', padding: '8px', marginBottom: '10px', color: 'inherit', background: 'transparent', borderRadius: '4px', border: '1px solid rgba(34,211,238,0.2)' }}
                    />
                  </div>

                  <div>
                    <MDTypography>
                      <label>Quantity:</label>
                    </MDTypography>
                    <input
                      type='number'
                      value={quantity}
                      onChange={(e) => setQuantity(e.target.value)}
                      required
                      style={{ width: '100%', padding: '8px', marginBottom: '10px', color: 'inherit', background: 'transparent', borderRadius: '4px', border: '1px solid rgba(34,211,238,0.2)' }}
                    />
                  </div>

                  <div>
                    <MDTypography>
                      <label>Start Date:</label>
                    </MDTypography>
                    <input
                      type='datetime-local'
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                      required
                      style={{ width: '100%', padding: '8px', marginBottom: '10px', color: 'inherit', background: 'transparent', borderRadius: '4px', border: '1px solid rgba(34,211,238,0.2)' }}
                    />
                  </div>

                  <div>
                    <MDTypography>
                      <label>End Date:</label>
                    </MDTypography>
                    <input
                      type='datetime-local'
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                      required
                      style={{ width: '100%', padding: '8px', marginBottom: '10px', color: 'inherit', background: 'transparent', borderRadius: '4px', border: '1px solid rgba(34,211,238,0.2)' }}
                    />
                  </div>
                  <div>
                    <MDTypography>
                      <label>Bet Limit (optional):</label>
                    </MDTypography>
                    <select
                      value={accessCodeBetLimitId}
                      onChange={(e) => setAccessCodeBetLimitId(e.target.value)}
                      style={{ width: '100%', padding: '8px', marginBottom: '10px', color: 'inherit', background: 'transparent', borderRadius: '4px', border: '1px solid rgba(34,211,238,0.2)' }}
                    >
                      <option value=''>Game-wide</option>
                      {betLimits?.map((limit) => (
                        <option key={limit.id} value={limit.id}>
                          {limit.singleBet ? `${Number(limit.singleBet)}$` : `${limit.minBet} - ${limit.maxBet}`}
                        </option>
                      ))}
                    </select>
                  </div>

                  <button
                    type='submit'
                    disabled={loading}
                    style={{
                      width: '100%',
                      padding: '10px',
                      background: loading ? '#ccc' : '#007bff',
                      color: '#fff',
                      border: 'none',
                      cursor: loading ? 'not-allowed' : 'pointer'
                    }}
                  >
                    {loading ? 'Submitting...' : 'Submit'}
                  </button>
                </form>
              </Grid>
            </Grid>

            <Grid item xs={12} xl={8}>
              <Can I='update' a='AethirChecks'>
                {game.game !== 'jetpack2d' && game.game !== 'nicehash-game' && (
                  <Grid item xs={12} sx={{ marginTop: '30px' }}>
                    <MDTypography sx={{ fontSize: '16px', fontWeight: '600' }}>Aethir Checks</MDTypography>
                    <MDBox
                      sx={{
                        border: '1px solid rgba(34,211,238,0.15)',
                        borderRadius: '10px',
                        padding: '20px',
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '20px',
                        background: 'linear-gradient(145deg, #1a2744 0%, #1e3058 50%, #131f3a 100%)',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        marginTop: '10px'
                      }}
                    >
                      <MDInput label='Aethir Id' value={aethirId} onChange={(e) => setAethirId(e?.target?.value)} sx={darkInputSx} />
                      <MDInput
                        label='Aethir Id US'
                        value={aethirIdUS}
                        onChange={(e) => setAethirIdUS(e?.target?.value)}
                        sx={darkInputSx}
                      />
                      <MDInput label='Server IP' value={serverIp} onChange={(e) => setServerIp(e?.target?.value)} sx={darkInputSx} />
                      <FormControlLabel
                        sx={{ '& .MuiFormControlLabel-label': { color: '#d3ddf5' } }}
                        control={
                          <Checkbox
                            checked={isAethirActive}
                            onChange={(e) => setIsAethirActive(e?.target?.checked)}
                            sx={{ color: 'rgba(211,221,245,0.5)', '&.Mui-checked': { color: '#22d3ee' } }}
                          />
                        }
                        label='Aethir Active'
                      />
                      <FormControlLabel
                        sx={{ '& .MuiFormControlLabel-label': { color: '#d3ddf5' } }}
                        control={
                          <Checkbox
                            checked={isAethirUSActive}
                            onChange={(e) => setIsAethirUSActive(e?.target?.checked)}
                            sx={{ color: 'rgba(211,221,245,0.5)', '&.Mui-checked': { color: '#22d3ee' } }}
                          />
                        }
                        label='Aethir US Active'
                      />
                      <MDButton variant='contained' color='info' onClick={saveAethirChecks}>
                        Save
                      </MDButton>
                    </MDBox>
                  </Grid>
                )}
              </Can>
              <Grid item xs={12}>
                <MDTypography sx={{ fontSize: '16px', fontWeight: '600' }}>Bet Limits</MDTypography>
                <MDBox
                  sx={{
                    border: '1px solid rgba(34,211,238,0.15)',
                    borderRadius: '10px',
                    padding: '20px',
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '20px',
                    background: 'linear-gradient(145deg, #1a2744 0%, #1e3058 50%, #131f3a 100%)',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    marginTop: '10px'
                  }}
                >
                  {betLimits &&
                    betLimits.map((limit) => {
                      return (
                        <BetLimit
                          id={limit.id}
                          gameType={game.game}
                          minBet={limit.minBet ? Number(limit.minBet) : limit.minBet}
                          maxBet={limit.maxBet ? Number(limit.maxBet) : limit.maxBet}
                          singleBet={limit.singleBet ? Number(limit.singleBet) : limit.singleBet}
                          gameId={gameId}
                          initialAddresses={limit.addresses}
                          initialAirdropPercentage={
                            limit.airdropPercentage ? Number(limit.airdropPercentage) : limit.airdropPercentage
                          }
                          initialJackpotPercentage={
                            limit.jackpotPercentage ? Number(limit.jackpotPercentage) : limit.jackpotPercentage
                          }
                          initialFirstPlacePercentage={
                            limit.firstPlacePercentage ? Number(limit.firstPlacePercentage) : limit.firstPlacePercentage
                          }
                          initialSecondPlacePercentage={
                            limit.secondPlacePercentage
                              ? Number(limit.secondPlacePercentage)
                              : limit.secondPlacePercentage
                          }
                          initialThirdPlacePercentage={
                            limit.thirdPlacePercentage ? Number(limit.thirdPlacePercentage) : limit.thirdPlacePercentage
                          }
                          initialBossPercentage={
                            limit.bossPercentage ? Number(limit.bossPercentage) : limit.bossPercentage
                          }
                          initialThresholdMultiplier={
                            limit.thresholdMultiplier ? Number(limit.thresholdMultiplier) : limit.thresholdMultiplier
                          }
                          initialPreset={limit.preset}
                          initialPresetMinAmount={
                            limit.presetMinAmount ? Number(limit.presetMinAmount) : limit.presetMinAmount
                          }
                          initialAirdropMeterThreshold={
                            limit.airdropMeterThreshold ? Number(limit.airdropMeterThreshold) : 500
                          }
                          initialAirdropMinimumPot={
                            limit.airdropMinimumPot != null ? Number(limit.airdropMinimumPot) : 0
                          }
                          initialEnabled={limit.enabled}
                          initialRequireAccessCode={limit.requireAccessCode}
                          initialShowInCryptoExpressLobby={limit.showInCryptoExpressLobby}
                          initialAutoBidIntervalMs={
                            limit.autoBidIntervalMs != null ? Number(limit.autoBidIntervalMs) : 2000
                          }
                        ></BetLimit>
                      );
                    })}
                  <MDBox sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                    <MDButton color={'info'} sx={{ width: '30%', alignSelf: 'center' }} onClick={handleOpenAddBetLimit}>
                      Add new
                    </MDButton>
                  </MDBox>
                </MDBox>
                {modal && (
                  <Dialog
                    open={handleModal}
                    onClose={handleModal}
                    aria-labelledby='alert-dialog-title'
                    aria-describedby='alert-dialog-description'
                  >
                    <DialogTitle
                      id='alert-dialog-title'
                      sx={{ width: '100%', textAlign: 'center' }}
                    >{`Generated access tokens`}</DialogTitle>
                    <MDButton variant='contained' color='secondary' onClick={handleCopy} sx={{ marginTop: '10px' }}>
                      {copied ? 'Copied!' : 'Copy All'}
                    </MDButton>
                    <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: '5px', padding: '20px 30px' }}>
                      {tokens?.map((t, i) => (
                        <MDTypography key={i}>{t?.code}</MDTypography>
                      ))}
                    </DialogContent>
                  </Dialog>
                )}
                <Grid container gap={5}>
                  <Grid item xs={12}>
                    <MDTypography sx={{ fontSize: '16px', fontWeight: '600', marginTop: '10px' }}>
                      Active sessions
                    </MDTypography>
                    <MDBox
                      sx={{
                        border: '1px solid rgba(34,211,238,0.15)',
                        borderRadius: '10px',
                        padding: '20px',
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '20px',
                        background: 'linear-gradient(145deg, #1a2744 0%, #1e3058 50%, #131f3a 100%)',
                        justifyContent: 'flex-start',
                        alignItems: 'flex-start',
                        marginTop: '10px'
                      }}
                    >
                      <MDBox
                        sx={{
                          display: 'flex',
                          gap: '10px',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          width: '100%'
                        }}
                      >
                        <label style={{ fontSize: '14px', color: '#FFF', fontWeight: '600' }}>Active servers</label>
                        <MDTypography sx={{ fontSize: '14px', color: '#FFF' }}>
                          {(activeSessions?.activeServersForGame != undefined &&
                            Object.entries(activeSessions?.activeServersForGame)
                              ?.map(([server, p]) => server)
                              ?.map((val, i) => {
                                return (
                                  <span>
                                    {val}
                                    {i < activeSessions?.activeServersForGame?.size - 1 ? ', ' : ''}
                                  </span>
                                );
                              })) ||
                            '-'}
                        </MDTypography>
                      </MDBox>
                      <MDBox
                        sx={{
                          display: 'flex',
                          gap: '10px',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          width: '100%'
                        }}
                      >
                        <label style={{ fontSize: '14px', color: '#FFF', fontWeight: '600' }}>Currently active</label>
                        <MDTypography sx={{ fontSize: '14px', color: '#FFF' }}>
                          {activeSessions?.activeSessionsGame || 0}
                        </MDTypography>
                      </MDBox>
                      <label style={{ fontSize: '14px', color: '#FFF', fontWeight: '600' }}>
                        Currently active per bet
                      </label>
                      {betLimits &&
                        betLimits.map((limit) => {
                          return (
                            <MDBox
                              sx={{
                                display: 'flex',
                                gap: '10px',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                width: '100%'
                              }}
                            >
                              <label style={{ fontSize: '14px', color: '#FFF', fontWeight: '600' }}>
                                Bet: {limit.singleBet ? limit.singleBet : `${limit.minBet} - ${limit.maxBet}`}
                              </label>
                              <MDTypography sx={{ fontSize: '14px', color: '#FFF' }}>
                                Active users:{' '}
                                {activeSessions?.activeSessionsPerLimit?.find((bet) => bet.id === limit.id)?.count || 0}
                              </MDTypography>
                            </MDBox>
                          );
                        })}
                    </MDBox>
                  </Grid>
                  <Grid xs={12}>
                    <MDBox sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <MDTypography sx={{ fontSize: '16px', fontWeight: '600' }}>Tournaments</MDTypography>
                      <MDButton color='info' onClick={() => setOpenAddTournament(true)}>
                        Add tournament
                      </MDButton>
                    </MDBox>
                    {torunaments && torunaments.length > 0 && (
                      <MDBox
                        sx={{
                          border: '1px solid rgba(34,211,238,0.15)',
                          borderRadius: '10px',
                          padding: '20px',
                          display: 'flex',
                          gap: '20px',
                          background: 'linear-gradient(145deg, #1a2744 0%, #1e3058 50%, #131f3a 100%)',
                          justifyContent: 'flex-start',
                          alignItems: 'flex-start',
                          overflowX: 'scroll',
                          marginTop: '10px'
                        }}
                      >
                        {torunaments?.map((tournament) => {
                          return (
                            <MDBox
                              sx={{
                                border: '1px solid rgba(255,255,255,0.15)',
                                borderRadius: '10px',
                                padding: '12px 16px',
                                display: 'flex',
                                flexDirection: 'column',
                                flexWrap: 'wrap',
                                gap: '20px',
                                background: '#ffffff14',
                                justifyContent: 'flex-start',
                                alignItems: 'center',
                                marginTop: '10px',
                                width: '50%',
                                boxSizing: 'border-box'
                              }}
                            >
                              <MDTypography sx={{ color: '#FFF', fontWeight: 700 }}>{tournament?.name}</MDTypography>
                              <MDBox
                                sx={{
                                  display: 'flex',
                                  gap: '20px',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  width: '100%',
                                  color: '#FFF !important',
                                  fontSize: '16px'
                                }}
                              >
                                <p>Start day of the week:</p>
                                <p style={{ textAlign: 'right' }}>
                                  <strong>{tournament?.startDayOfWeek}</strong> (
                                  {tournament?.isDaily ? 'Daily' : tournament?.recurring ? 'Recurring' : 'Not recurring'})
                                </p>
                              </MDBox>
                              <MDBox
                                sx={{
                                  display: 'flex',
                                  gap: '20px',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  width: '100%',
                                  color: '#FFF !important',
                                  fontSize: '16px'
                                }}
                              >
                                <p>Start time:</p>
                                <p>{convertUTCTimeToLocal(tournament?.startTime)}</p>
                              </MDBox>
                              <MDBox
                                sx={{
                                  display: 'flex',
                                  gap: '20px',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  width: '100%',
                                  color: '#FFF !important',
                                  fontSize: '16px'
                                }}
                              >
                                <p>End day of the week:</p>
                                <p style={{ textAlign: 'right' }}>
                                  <strong>{tournament?.endDayOfWeek}</strong>
                                </p>
                              </MDBox>
                              <MDBox
                                sx={{
                                  display: 'flex',
                                  gap: '20px',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  width: '100%',
                                  color: '#FFF !important',
                                  fontSize: '16px'
                                }}
                              >
                                <p>End time:</p>
                                <p>{convertUTCTimeToLocal(tournament?.endTime)}</p>
                              </MDBox>
                              <MDBox
                                sx={{
                                  display: 'flex',
                                  gap: '20px',
                                  justifyContent: 'space-between',
                                  alignItems: 'flex-start',
                                  width: '100%',
                                  color: '#FFF !important',
                                  fontSize: '16px'
                                }}
                              >
                                <p>Prizes:</p>
                                <MDBox
                                  sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '20px',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    color: '#FFF !important',
                                    fontSize: '16px'
                                  }}
                                >
                                  <p>
                                    1st place:{' '}
                                    <strong>
                                      {tournament?.firstPlacePrize}
                                      {tournament?.currency}
                                    </strong>
                                  </p>
                                  <p>
                                    2nd place:{' '}
                                    <strong>
                                      {tournament?.secondPlacePrize}
                                      {tournament?.currency}
                                    </strong>
                                  </p>
                                  <p>
                                    3rd place:{' '}
                                    <strong>
                                      {tournament?.thirdPlacePrize}
                                      {tournament?.currency}
                                    </strong>
                                  </p>
                                </MDBox>
                              </MDBox>
                              <MDBox
                                sx={{
                                  display: 'flex',
                                  gap: '20px',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  width: '100%',
                                  color: '#FFF !important',
                                  fontSize: '16px'
                                }}
                              >
                                <p>Enabled:</p>
                                {/* <p style={{ color: tournament?.enabled ? '#21a921' : '#c41e1e', fontWeight: '700' }}>
                                {tournament?.enabled ? 'Yes' : 'No'}
                              </p> */}
                                <Button
                                  variant='outlined'
                                  onClick={() => handleTournament(tournament.id, !tournament.enabled)}
                                  sx={{
                                    fontWeight: 700,
                                    borderRadius: '12px',
                                    textTransform: 'none',
                                    px: 3,
                                    py: 1,
                                    borderColor: tournament.enabled ? '#21a921' : '#c41e1e',
                                    color: tournament.enabled ? '#21a921' : '#c41e1e',
                                    '&:hover': {
                                      borderColor: tournament.enabled ? '#178917' : '#a31515',
                                      backgroundColor: tournament.enabled
                                        ? 'rgba(33, 169, 33, 0.08)'
                                        : 'rgba(196, 30, 30, 0.08)'
                                    }
                                  }}
                                >
                                  {tournament.enabled ? 'Yes' : 'No'}
                                </Button>
                              </MDBox>
                              <MDBox
                                sx={{ display: 'flex', gap: '20px', justifyContent: 'space-between', width: '100%' }}
                              >
                                <MDButton
                                  onClick={() => {
                                    navigate(`/tournament/${tournament.id}`);
                                  }}
                                >
                                  go to leaderboard
                                </MDButton>
                                <MDButton
                                  color='error'
                                  onClick={() => {
                                    setDeleteTournamentId(tournament?.id);
                                    setOpenDeleteTournament(true);
                                  }}
                                >
                                  Delete tournament
                                </MDButton>
                              </MDBox>
                            </MDBox>
                          );
                        })}
                      </MDBox>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid container spacing={1} sx={{ marginTop: '20px' }}>
            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <MDTypography sx={{ fontSize: '16px', fontWeight: '600' }}>Avatars</MDTypography>
              <MDButton color='info' onClick={handleOpenAddAvatar}>
                Add new avatar
              </MDButton>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', flexWrap: 'wrap' }}
            >
              {avatars && avatars.length > 0 ? (
                avatars.map((avatar) => {
                  return (
                    <Grid item xs={12} sm={6} lg={3} sx={{ padding: '15px' }}>
                      <MDBox
                        sx={{
                          background: 'linear-gradient(145deg, #1a2744 0%, #1e3058 50%, #131f3a 100%)',
                          borderRadius: '10px',
                          border: '0.5px solid rgba(255,255,255,0.15)',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'center',
                          alignItems: 'center',
                          paddingBottom: '15px'
                        }}
                      >
                        <MDTypography
                          sx={{
                            padding: '10px 0',
                            width: '100%',
                            textAlign: 'center',
                            background: '#121c35',
                            borderRadius: '10px 10px 0 0',
                            fontWeight: '600',
                            fontSize: '16px',
                            color: '#fff'
                          }}
                        >
                          {avatar.name}
                        </MDTypography>
                        <img src={avatar.image} style={{ width: '200px' }}></img>
                        <MDBox sx={{ display: 'flex', padding: '10px', gap: '10px' }}>
                          <MDButton
                            onClick={() => {
                              handleOpenEditAvatar();
                              setEditAvatarId(avatar.id);
                              setEditAvatarName(avatar.name);
                              setEditAvatarPosition(avatar.position);
                            }}
                          >
                            Edit Avatar
                          </MDButton>
                          <MDButton
                            onClick={() => {
                              handleOpenDeleteAvatar();
                              setDeleteAvatarId(avatar.id);
                            }}
                          >
                            Delete Avatar
                          </MDButton>
                        </MDBox>
                      </MDBox>
                    </Grid>
                  );
                })
              ) : (
                <MDBox
                  sx={{
                    width: '100%',
                    textAlign: 'center',
                    paddingBottom: '30px'
                  }}
                >
                  <MDTypography sx={{ fontSize: '14px' }}>No avatars available.</MDTypography>
                </MDBox>
              )}
            </Grid>
          </Grid>
        </MDBox>

        <Dialog
          open={openEditAvatar}
          onClose={handleCloseEditAvatar}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle id='alert-dialog-title' sx={{ width: '100%', textAlign: 'center' }}>{`Edit avatar`}</DialogTitle>
          <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: '5px', padding: '20px 30px' }}>
            <MDTypography sx={{ fontSize: '16px' }}>Avatar name</MDTypography>
            <input
              type='text'
              value={editAvatarName}
              onChange={(e) => {
                setEditAvatarName(e.target.value);
              }}
              style={{ padding: '10px 15px', borderRadius: '8px', border: '1px solid rgba(34,211,238,0.2)', width: '500px', color: 'inherit', background: 'transparent' }}
            />
            <MDTypography sx={{ fontSize: '16px' }}>Avatar Position</MDTypography>
            <input
              type='text'
              value={editAvatarPosition}
              onChange={(e) => {
                setEditAvatarPosition(e.target.value);
              }}
              style={{ padding: '10px 15px', borderRadius: '8px', border: '1px solid rgba(34,211,238,0.2)', width: '500px', color: 'inherit', background: 'transparent' }}
            />
            <MDTypography sx={{ fontSize: '16px', marginTop: '10px' }}>Avatar image</MDTypography>
            <input type='file' onChange={handleEditAvatarChange} />
          </DialogContent>
          <DialogActions>
            <MDButton variant='text' onClick={handleCloseEditAvatar}>
              Close
            </MDButton>
            <MDButton
              color='info'
              onClick={() => {
                updateAvatar(editAvatarId, gameId, editAvatarName, editAvatarImage, editAvatarPosition);
                handleCloseEditAvatar();
              }}
            >
              Save
            </MDButton>
          </DialogActions>
        </Dialog>

        <Dialog
          open={openAddAvatar}
          onClose={handleCloseAddAvatar}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle
            id='alert-dialog-title'
            sx={{ width: '100%', textAlign: 'center' }}
          >{`Add new avatar`}</DialogTitle>
          <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: '5px', padding: '20px 30px' }}>
            <MDTypography sx={{ fontSize: '16px' }}>Avatar name</MDTypography>
            <input
              type='text'
              value={addAvatarName}
              onChange={(e) => {
                setAddAvatarName(e.target.value);
              }}
              style={{ padding: '10px 15px', borderRadius: '8px', border: '1px solid rgba(34,211,238,0.2)', width: '500px', color: 'inherit', background: 'transparent' }}
            />
            <MDTypography sx={{ fontSize: '16px' }}>Avatar Position</MDTypography>
            <input
              type='text'
              value={addAvatarPosition}
              onChange={(e) => {
                setAddAvatarPosition(e.target.value);
              }}
              style={{ padding: '10px 15px', borderRadius: '8px', border: '1px solid rgba(34,211,238,0.2)', width: '500px', color: 'inherit', background: 'transparent' }}
            />
            <MDTypography sx={{ fontSize: '16px', marginTop: '10px' }}>Avatar image</MDTypography>
            <input type='file' onChange={handleAddAvatarChange} />
          </DialogContent>
          <DialogActions>
            <MDButton variant='text' onClick={handleCloseAddAvatar}>
              Close
            </MDButton>
            <MDButton
              color='info'
              onClick={() => {
                addAvatar(gameId, addAvatarName, addAvatarImage, addAvatarPosition);
                handleCloseAddAvatar();
              }}
            >
              Save
            </MDButton>
          </DialogActions>
        </Dialog>

        <Dialog
          open={openAddBetLimit}
          onClose={handleCloseAddBetLimit}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle
            id='alert-dialog-title'
            sx={{ width: '100%', textAlign: 'center' }}
          >{`Add New Bet Limit`}</DialogTitle>
          <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: '5px', padding: '20px 30px' }}>
            {(limitType === 'minMax' || limitType === 'none') && (
              <>
                <MDTypography sx={{ fontSize: '16px' }}>Min Bet</MDTypography>
                <input
                  type='number'
                  value={newLimitMinBet}
                  onChange={(e) => {
                    setNewLimitMinBet(e.target.value);
                  }}
                  style={{ padding: '10px 15px', borderRadius: '8px', border: '1px solid rgba(34,211,238,0.2)', width: '500px', color: 'inherit', background: 'transparent' }}
                />
                <MDTypography sx={{ fontSize: '16px', marginTop: '10px' }}>Max Bet</MDTypography>
                <input
                  type='number'
                  value={newLimitMaxBet}
                  onChange={(e) => {
                    setNewLimitMaxBet(e.target.value);
                  }}
                  style={{ padding: '10px 15px', borderRadius: '8px', border: '1px solid rgba(34,211,238,0.2)', width: '500px', color: 'inherit', background: 'transparent' }}
                />
              </>
            )}
            {(limitType === 'single' || limitType === 'none') && (
              <>
                <MDTypography sx={{ fontSize: '16px' }}>Single Bet</MDTypography>
                <input
                  type='number'
                  value={newLimitSingleBet}
                  onChange={(e) => {
                    setNewLimitSingleBet(e.target.value);
                  }}
                  style={{ padding: '10px 15px', borderRadius: '8px', border: '1px solid rgba(34,211,238,0.2)', width: '500px', color: 'inherit', background: 'transparent' }}
                />
              </>
            )}
          </DialogContent>
          <DialogActions>
            <MDButton variant='text' onClick={handleCloseAddBetLimit}>
              Close
            </MDButton>
            <MDButton
              color='info'
              onClick={() => {
                addBetLimit(gameId, newLimitMinBet, newLimitMaxBet, newLimitSingleBet);
                handleCloseAddBetLimit();
                fetchGame();
              }}
            >
              Add
            </MDButton>
          </DialogActions>
        </Dialog>

        <Dialog
          open={openDeleteAvatar}
          onClose={handleCloseDeleteAvatar}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle
            id='alert-dialog-title'
            sx={{ width: '100%', textAlign: 'center' }}
          >{`Are you sure you want to delete this avatar?`}</DialogTitle>
          <DialogActions>
            <MDButton
              variant='text'
              color='error'
              onClick={() => {
                deleteAvatar(deleteAvatarId);
                setRerender(!rerender);
                handleCloseDeleteAvatar();
              }}
            >
              Yes
            </MDButton>
            <MDButton
              variant='text'
              onClick={() => {
                handleCloseDeleteAvatar();
              }}
            >
              No
            </MDButton>
          </DialogActions>
        </Dialog>

        <Dialog
          open={openAddTournament}
          onClose={() => setOpenAddTournament(false)}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle
            id='alert-dialog-title'
            sx={{ width: '100%', textAlign: 'center' }}
          >{`Add new tournament`}</DialogTitle>
          <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: '5px', padding: '20px 30px' }}>
            <form style={{ width: '500px' }}>
              <div
                key={'betLimitId'}
                style={{ marginBottom: '10px', display: 'flex', flexDirection: 'column', gap: '5px' }}
              >
                <MDTypography sx={{ fontSize: '16px' }}>Bet Limit</MDTypography>
                <select
                  style={{
                    padding: '10px 15px',
                    borderRadius: '8px',
                    border: newTournamentErrors.betLimitId ? '1px solid red' : '1px solid #344767',
                    width: '100%',
                    boxSizing: 'border-box',
                    color: 'inherit',
                    background: 'transparent'
                  }}
                  onChange={(e) => handleFieldChange('betLimitId', e.target.value)}
                >
                  <option disabled selected>
                    Please select bet
                  </option>
                  {betLimits?.map((limit) => {
                    return (
                      <option value={limit?.id} disabled={limit?.singleBet !== '3'}>
                        {limit?.singleBet}
                      </option>
                    );
                  })}
                </select>
                {newTournamentErrors.betLimitId && (
                  <MDTypography sx={{ fontSize: '12px', color: 'red' }}>Please select bet limit!</MDTypography>
                )}
              </div>
              <div key={'name'} style={{ marginBottom: '10px', display: 'flex', flexDirection: 'column', gap: '5px' }}>
                <MDTypography sx={{ fontSize: '16px' }}>Name</MDTypography>
                <input
                  type='text'
                  id={'name'}
                  name={'name'}
                  value={newTournament['name']}
                  onChange={(e) => handleFieldChange('name', e.target.value)}
                  style={{
                    padding: '10px 15px',
                    borderRadius: '8px',
                    border: newTournamentErrors.name ? '1px solid red' : '1px solid #344767',
                    width: '100%',
                    boxSizing: 'border-box',
                    color: 'inherit',
                    background: 'transparent'
                  }}
                  placeholder='Example name'
                />
                {newTournamentErrors.name && (
                  <MDTypography sx={{ fontSize: '12px', color: 'red' }}>Please choose a name!</MDTypography>
                )}
              </div>
              {!newTournament.isDaily && (
                <div
                  key={'start-day'}
                  style={{ marginBottom: '10px', display: 'flex', flexDirection: 'column', gap: '5px' }}
                >
                  <MDTypography sx={{ fontSize: '16px' }}>Start day of the week</MDTypography>
                  <select
                    value={newTournament.startDayOfWeek || ''}
                    style={{
                      padding: '10px 15px',
                      borderRadius: '8px',
                      border: newTournamentErrors.startDayOfWeek ? '1px solid red' : '1px solid #344767',
                      width: '100%',
                      boxSizing: 'border-box',
                      color: 'inherit',
                      background: 'transparent'
                    }}
                    onChange={(e) => handleFieldChange('startDayOfWeek', e.target.value)}
                  >
                    <option disabled value=''>
                      Please select day
                    </option>
                    <option value={'Monday'}>Monday</option>
                    <option value={'Tuesday'}>Tuesday</option>
                    <option value={'Wednesday'}>Wednesday</option>
                    <option value={'Thursday'}>Thursday</option>
                    <option value={'Friday'}>Friday</option>
                    <option value={'Saturday'}>Saturday</option>
                    <option value={'Sunday'}>Sunday</option>
                  </select>
                  {newTournamentErrors.startDayOfWeek && (
                    <MDTypography sx={{ fontSize: '12px', color: 'red' }}>Please select day!</MDTypography>
                  )}
                </div>
              )}
              <div key={'start'} style={{ marginBottom: '10px', display: 'flex', flexDirection: 'column', gap: '5px' }}>
                <MDTypography sx={{ fontSize: '16px' }}>Start time</MDTypography>
                <input
                  type='text'
                  id={'start'}
                  name={'start'}
                  value={newTournament['startTime']}
                  onChange={(e) => handleFieldChange('startTime', e.target.value)}
                  style={{
                    padding: '10px 15px',
                    borderRadius: '8px',
                    border: newTournamentErrors.startTime ? '1px solid red' : '1px solid #344767',
                    width: '100%',
                    boxSizing: 'border-box',
                    color: 'inherit',
                    background: 'transparent'
                  }}
                  placeholder='08:00'
                />
                {newTournamentErrors.startTime && (
                  <MDTypography sx={{ fontSize: '12px', color: 'red' }}>Please select start time!</MDTypography>
                )}
              </div>
              {!newTournament.isDaily && (
                <div
                  key={'end-day'}
                  style={{ marginBottom: '10px', display: 'flex', flexDirection: 'column', gap: '5px' }}
                >
                  <MDTypography sx={{ fontSize: '16px' }}>End day of the week</MDTypography>
                  <select
                    value={newTournament.endDayOfWeek || ''}
                    style={{
                      padding: '10px 15px',
                      borderRadius: '8px',
                      border: newTournamentErrors.endDayOfWeek ? '1px solid red' : '1px solid #344767',
                      width: '100%',
                      boxSizing: 'border-box',
                      color: 'inherit',
                      background: 'transparent'
                    }}
                    onChange={(e) => handleFieldChange('endDayOfWeek', e.target.value)}
                  >
                    <option disabled value=''>
                      Please select day
                    </option>
                    <option value={'Monday'}>Monday</option>
                    <option value={'Tuesday'}>Tuesday</option>
                    <option value={'Wednesday'}>Wednesday</option>
                    <option value={'Thursday'}>Thursday</option>
                    <option value={'Friday'}>Friday</option>
                    <option value={'Saturday'}>Saturday</option>
                    <option value={'Sunday'}>Sunday</option>
                  </select>
                  {newTournamentErrors.endDayOfWeek && (
                    <MDTypography sx={{ fontSize: '12px', color: 'red' }}>Please select day!</MDTypography>
                  )}
                </div>
              )}
              <div key={'end'} style={{ marginBottom: '10px', display: 'flex', flexDirection: 'column', gap: '5px' }}>
                <MDTypography sx={{ fontSize: '16px' }}>End time</MDTypography>
                <input
                  type='text'
                  id={'end'}
                  name={'end'}
                  value={newTournament['endTime']}
                  onChange={(e) => handleFieldChange('endTime', e.target.value)}
                  style={{
                    padding: '10px 15px',
                    borderRadius: '8px',
                    border: newTournamentErrors.endTime ? '1px solid red' : '1px solid #344767',
                    width: '100%',
                    boxSizing: 'border-box',
                    color: 'inherit',
                    background: 'transparent'
                  }}
                  placeholder='15:00'
                />
                {newTournamentErrors.endTime && (
                  <MDTypography sx={{ fontSize: '12px', color: 'red' }}>Please select end time!</MDTypography>
                )}
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                <div
                  key={'firstPlacePrize'}
                  style={{ marginBottom: '10px', display: 'flex', flexDirection: 'column', gap: '5px' }}
                >
                  <MDTypography sx={{ fontSize: '16px' }}>1st place</MDTypography>
                  <input
                    type='number'
                    id={'firstPlacePrize'}
                    name={'firstPlacePrize'}
                    value={newTournament['firstPlacePrize']}
                    onChange={(e) => handleFieldChange('firstPlacePrize', e.target.value)}
                    style={{
                      padding: '10px 15px',
                      borderRadius: '8px',
                      border: newTournamentErrors.firstPlacePrize ? '1px solid red' : '1px solid #344767',
                      width: '100%',
                      boxSizing: 'border-box',
                      color: 'inherit',
                      background: 'transparent'
                    }}
                    placeholder='10'
                  />
                </div>
                <div
                  key={'secondPlacePrize'}
                  style={{ marginBottom: '10px', display: 'flex', flexDirection: 'column', gap: '5px' }}
                >
                  <MDTypography sx={{ fontSize: '16px' }}>2nd place</MDTypography>
                  <input
                    type='number'
                    id={'secondPlacePrize'}
                    name={'secondPlacePrize'}
                    value={newTournament['secondPlacePrize']}
                    onChange={(e) => handleFieldChange('secondPlacePrize', e.target.value)}
                    style={{
                      padding: '10px 15px',
                      borderRadius: '8px',
                      border: '1px solid #344767',
                      width: '100%',
                      boxSizing: 'border-box',
                      color: 'inherit',
                      background: 'transparent'
                    }}
                    placeholder='5'
                  />
                </div>
                <div
                  key={'thirdPlacePrize'}
                  style={{ marginBottom: '10px', display: 'flex', flexDirection: 'column', gap: '5px' }}
                >
                  <MDTypography sx={{ fontSize: '16px' }}>3rd place</MDTypography>
                  <input
                    type='number'
                    id={'thirdPlacePrize'}
                    name={'thirdPlacePrize'}
                    value={newTournament['thirdPlacePrize']}
                    onChange={(e) => handleFieldChange('thirdPlacePrize', e.target.value)}
                    style={{
                      padding: '10px 15px',
                      borderRadius: '8px',
                      border: '1px solid #344767',
                      width: '100%',
                      boxSizing: 'border-box',
                      color: 'inherit',
                      background: 'transparent'
                    }}
                    placeholder='1'
                  />
                </div>
                <div
                  key={'currency'}
                  style={{ marginBottom: '10px', display: 'flex', flexDirection: 'column', gap: '5px' }}
                >
                  <MDTypography sx={{ fontSize: '16px' }}>Currency</MDTypography>
                  <select
                    style={{
                      padding: '10px 15px',
                      borderRadius: '8px',
                      border: newTournamentErrors.currency ? '1px solid red' : '1px solid #344767',
                      width: '100%',
                      boxSizing: 'border-box',
                      color: 'inherit',
                      background: 'transparent'
                    }}
                    onChange={(e) => handleFieldChange('currency', e.target.value)}
                  >
                    <option disabled selected>
                      Select currency
                    </option>
                    {currencies?.map((currency) => {
                      return <option value={currency}>{currency}</option>;
                    })}
                  </select>
                </div>
              </div>
              {newTournamentErrors.firstPlacePrize && (
                <MDTypography sx={{ fontSize: '12px', color: 'red' }}>Please select first place prize!</MDTypography>
              )}
              {newTournamentErrors.currency && (
                <MDTypography sx={{ fontSize: '12px', color: 'red' }}>Please select currency!</MDTypography>
              )}
              <div
                key={'recurring'}
                style={{
                  margin: '10px 0',
                  display: 'flex',
                  justifyContent: 'space-between',
                  gap: '5px',
                  width: '100%',
                  opacity: newTournament['isDaily'] ? 0.5 : 1
                }}
              >
                <MDTypography sx={{ fontSize: '16px' }}>Recurring</MDTypography>
                <input
                  type='checkbox'
                  id={'recurring'}
                  name={'recurring'}
                  checked={newTournament['recurring']}
                  disabled={newTournament['isDaily']}
                  onChange={(e) => handleFieldChange('recurring', e.target.checked)}
                  style={{
                    borderRadius: '8px',
                    border: '1px solid #344767',
                    boxSizing: 'border-box',
                    width: '24px',
                    cursor: newTournament['isDaily'] ? 'not-allowed' : 'pointer',
                    accentColor: '#22d3ee'
                  }}
                  placeholder='15:00'
                />
              </div>
              <div
                key={'isDaily'}
                style={{
                  margin: '10px 0',
                  display: 'flex',
                  justifyContent: 'space-between',
                  gap: '5px',
                  width: '100%'
                }}
              >
                <MDTypography sx={{ fontSize: '16px' }}>Daily Tournament</MDTypography>
                <input
                  type='checkbox'
                  id={'isDaily'}
                  name={'isDaily'}
                  checked={newTournament['isDaily']}
                  onChange={(e) => {
                    const isDaily = e.target.checked;
                    handleFieldChange('isDaily', isDaily);
                    // Clear day of week errors when toggling daily
                    if (isDaily) {
                      handleErrorChange('startDayOfWeek', false);
                      handleErrorChange('endDayOfWeek', false);
                      // Daily tournaments are inherently recurring, so set recurring to true
                      handleFieldChange('recurring', true);
                    }
                  }}
                  style={{
                    borderRadius: '8px',
                    border: '1px solid #344767',
                    boxSizing: 'border-box',
                    width: '24px',
                    accentColor: '#22d3ee'
                  }}
                />
              </div>
              <div
                key={'requireAccessCode'}
                style={{
                  margin: '10px 0',
                  display: 'flex',
                  justifyContent: 'space-between',
                  gap: '5px',
                  width: '100%'
                }}
              >
                <MDTypography sx={{ fontSize: '16px' }}>Auto require access code</MDTypography>
                <input
                  type='checkbox'
                  id={'requireAccessCode'}
                  name={'requireAccessCode'}
                  checked={newTournament['requireAccessCode']}
                  onChange={(e) => handleFieldChange('requireAccessCode', e.target.checked)}
                  style={{
                    borderRadius: '8px',
                    border: '1px solid #344767',
                    boxSizing: 'border-box',
                    width: '24px',
                    accentColor: '#22d3ee'
                  }}
                />
              </div>
            </form>
          </DialogContent>
          <DialogActions>
            <MDButton
              variant='text'
              onClick={() => {
                setOpenAddTournament(false);
                Object.entries(newTournamentErrors).forEach(([field]) => {
                  handleErrorChange(field, false);
                });
              }}
            >
              Close
            </MDButton>
            <MDButton
              color='info'
              onClick={async () => {
                if (!checkFormFields()) {
                  await createTournament(
                    newTournament?.betLimitId,
                    newTournament?.name,
                    // For daily tournaments, day of week is not required (backend will set defaults)
                    newTournament?.isDaily ? undefined : newTournament?.startDayOfWeek,
                    newTournament?.isDaily ? undefined : newTournament?.endDayOfWeek,
                    localTimeToUTC(newTournament?.startTime),
                    localTimeToUTC(newTournament?.endTime),
                    newTournament?.firstPlacePrize !== '' ? Number(newTournament.firstPlacePrize) : 0,
                    newTournament?.secondPlacePrize !== '' ? Number(newTournament.secondPlacePrize) : 0,
                    newTournament?.thirdPlacePrize !== '' ? Number(newTournament.thirdPlacePrize) : 0,
                    newTournament?.currency,
                    newTournament?.recurring,
                    newTournament?.isDaily,
                    newTournament?.requireAccessCode
                  );
                  setRerender(!rerender);
                  setOpenAddTournament(false);
                  window.location.reload();
                }
              }}
            >
              Save
            </MDButton>
          </DialogActions>
        </Dialog>

        <Dialog
          open={openDeleteTournament}
          onClose={() => setOpenDeleteTournament(false)}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle
            id='alert-dialog-title'
            sx={{ width: '100%', textAlign: 'center' }}
          >{`Are you sure you want to delete this tournament?`}</DialogTitle>
          <DialogActions>
            <MDButton
              variant='text'
              color='error'
              onClick={async () => {
                await deleteTournament(deleteTournamentId);
                setRerender(!rerender);
                setOpenDeleteTournament(false);
                window.location.reload();
              }}
            >
              Yes
            </MDButton>
            <MDButton
              variant='text'
              onClick={() => {
                setOpenDeleteTournament(false);
              }}
            >
              No
            </MDButton>
          </DialogActions>
        </Dialog>
      </DashboardLayout>
    </>
  );
}

export default Game;
